<template>
  <div id="commercial-plane-anim" class="planes">
    <question-card
      v-if="showingQuestion && clickedObj"
      v-on:continueClicked="handleContinueClicked"
      v-on:submitClicked="handleSubmitClicked"
      v-on:finishClicked="handleFinishClicked"
      ref="questionCard"
      class="question-card"
      :title="clickedObj.title"
      :icon1="clickedObj.icon1"
      :answers="clickedObj.answers"
      :roomObject="clickedObj"
      :id="'question-' + clickedObj.id"
      :roomIndex="roomIndex"
      :buttonText="TestString"
      :outsideClicked="handleClickOutside"
      :allQuestionsAnswered="allQuestionsAnswered"
      :type="'commercial'"
    ></question-card>

    <div id="three-commercial-container" ref="three" class="plane-anim container">
      <room-button
        v-show="showRoomButtons"
        :class="'room-' + obj.name + ' object-' + obj.id + ' room-button-component'"
        :ref="obj.id + 'room' + obj.roomIndex"
        v-for="(obj, index) in roomObjs"
        v-on:obj-clicked="handleRoomButtonClick"
        :key="obj.id + 'room' + obj.roomIndex + obj.state"
        :top="obj.top"
        :left="obj.left"
        :buttonText="obj.text"
        :roomObj="obj"
        :status="obj.status"
        :title="obj.data.title"
        :isActive="activeRoomObjectIndex === index"
        :tl="obj.tl"
      ></room-button>

      <div id="scroller" ref="scroller">
        <div id="scroller_bg" ref="scroll_bg">
          <div class="scroller-indicators-container">
            <div class="scroller-indicator-large" :class="{ 'current-indicator': roomIndex === 0 }"></div>
            <div class="scroller-indicator-small"></div>
            <div class="scroller-indicator-large" :class="{ 'current-indicator': roomIndex === 1 }"></div>
            <div class="scroller-indicator-small"></div>
            <div class="scroller-indicator-large" :class="{ 'current-indicator': roomIndex === 2 }"></div>
            <div class="scroller-indicator-small"></div>
            <div class="scroller-indicator-large" :class="{ 'current-indicator': roomIndex === 3 }"></div>
            <div class="scroller-indicator-small"></div>
          </div>
        </div>
        <div class="scroll-arrow scroll-left" ref="scroll_left">
          <svg
            class="scroll-arrow-left"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            aria-label="previous room button"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 32 32"
            style="enable-background:new 0 0 32 32;"
            xml:space="preserve"
          >
            <circle class="st0" cx="16" cy="16" r="16" />
            <path
              class="st1"
              d="M11,17h7.5l-2.3,2.4c-0.2,0.2-0.2,0.5,0,0.7l0.7,0.7c0.2,0.2,0.5,0.2,0.7,0c0,0,0,0,0,0l4.3-4.5
            c0.2-0.2,0.2-0.5,0-0.7l-4.3-4.5c-0.2-0.2-0.5-0.2-0.7,0c0,0,0,0,0,0l-0.7,0.7c-0.2,0.2-0.2,0.5,0,0.7l2.3,2.4H11c-0.6,0-1,0.4-1,1
            v0C10,16.6,10.5,17,11,17z"
            />
          </svg>
        </div>
        <div class="scroll-arrow scroll-right" ref="scroll_right">
          <svg
            class="scroll-arrow-right"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            aria-label="next room button"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 32 32"
            style="enable-background:new 0 0 32 32;"
            xml:space="preserve"
          >
            <circle class="st0" cx="16" cy="16" r="16" />
            <path
              class="st1"
              d="M11,17h7.5l-2.3,2.4c-0.2,0.2-0.2,0.5,0,0.7l0.7,0.7c0.2,0.2,0.5,0.2,0.7,0c0,0,0,0,0,0l4.3-4.5
            c0.2-0.2,0.2-0.5,0-0.7l-4.3-4.5c-0.2-0.2-0.5-0.2-0.7,0c0,0,0,0,0,0l-0.7,0.7c-0.2,0.2-0.2,0.5,0,0.7l2.3,2.4H11c-0.6,0-1,0.4-1,1
            v0C10,16.6,10.5,17,11,17z"
            />
          </svg>
        </div>
      </div>

      <!-- <div
        data-name="play-again-button-wrapper"
        class="play-again-button-wrapper"
      >
        <div
          data-name="play-again-button-container"
          class="play-again-button-container orange-button"
        >
          <ui-button
            :buttonText="'Play Again'"
            :buttonAction="handlePlayAgainButtonClick"
          >
          </ui-button>
        </div>
      </div>-->
    </div>

    <transition @enter="handleHowToOverlayEnter" @leave="handleHowToOverlayLeave">
      <div id="howToOverlay" class="how-to-overlay" v-if="appState === 'instruction'"></div>
    </transition>
    <how-to-play-card ref="howToPlayCard" v-on:instructionsConfirmed="handleInstructionConfirmed"></how-to-play-card>

    <transition
      @before-enter="beforeTestimonialsEnter"
      @enter="testimonialsEnter"
      @leave="testimonialsLeave"
      :css="false"
    >
      <testimonials v-if="appState === 'show-testimonials'"></testimonials>
    </transition>

    <transition
      @before-enter="beforeFinalScoreEnter"
      @enter="handleFinalScoreEnter"
      @leave="handleFinalScoreLeave"
      :css="false"
    >
      <final-score-page id="finalScoreComponent" v-if="appState === 'finished'"></final-score-page>
    </transition>

    <transition
      @enter="handlePlayAgainButtonEnter"
      @leave="handlePlayAgainButtonLeave"
      :css="false"
    >
      <div
        id="playAgainDesktopButton"
        v-if="
                    !isMobile &&
                        (appState === 'finished' ||
                            appState === 'show-testimonials')
                "
        class="playAgainButtonWrapper"
      >
        <ui-button
          class="playAgainButton"
          :buttonAction="handlePlayAgainButtonClick"
          v-touch="handlePlayAgainButtonClick"
          buttonText="Play Again"
          title="Click to play again"
          aria-label="Click to play again"
        ></ui-button>
      </div>
    </transition>
  </div>
</template>

<script>
require("../../plugins/Projector.js");
require("../../plugins/CanvasRenderer.js");

import Vue from "vue";
import { isTouch } from "../../vendor/tactus";
import Rotator from "../../plugins/FixedRotate";
import { TweenMax, TimelineMax, Power2 } from "gsap";
import ThreeHelper from "../../plugins/threehelper";
import RoomButton from "../../components/RoomButton";
import QuestionCard from "../../components/QuestionCard";
import { mapGetters } from "vuex";
import isMobileMixin from "../../plugins/isMobileMixin.js";
import tweenSpeedsMixin from "../../plugins/tweenSpeedsMixin.js";
import PlaneAnimMixin from "../../plugins/PlaneAnimMixin.js";
import UiButton from "../UiButton";
import Detector from "../../plugins/Detector.js";
import PromisedLoad from "../../plugins/PromisedLoad.js";
import SplashScreenStartCard from "../SplashScreenStartCard";
import HowToPlayCard from "../Cards/HowToPlayCard";
import FinalScorePage from "../Pages/FinalScorePage";
import Testimonials from "../Testimonials";

// const TOTAL_QUESTIONS = 4;

export default {
  name: "CommercialPlaneAnim",
  mixins: [isMobileMixin, tweenSpeedsMixin, PlaneAnimMixin],
  data() {
    return {
      mouse: new THREE.Vector2(),
      raycaster: null,
      camera: null,
      cameraZoomLevel: 1,
      cameraFov: {
        fov: 70
      },
      scene: null,
      loader: null,
      textureLoader: null,
      elements: {
        container: null
      },
      rotator: null,
      rotatorEnabled: false,
      veggies: null,
      shadow: {
        mesh: null,
        exteriorTex: null,
        interiorTex: null
      },
      skybox: null,
      clock: null,
      roomObjs: [],
      textureSwapper: {
        fadeColor: new THREE.Color(0x2f6619),
        unfadeColor: new THREE.Color(0xffffff)
      },
      TestString: "Submit",
      showingQuestion: false,
      isSnapping: false,
      keyValue: true,
      roomIndex: 0,
      nextQuestionRoomIndex: null,
      nextQuestionIndex: null,
      activeRoomObjectIndex: null,
      allQuestionsAnswered: false,
      introAnimTl: null,
      showRoomButtons: false,
      walls: null
    };
  },
  components: {
    "room-button": RoomButton,
    "question-card": QuestionCard,
    "ui-button": UiButton,
    SplashScreenStartCard,
    HowToPlayCard,
    FinalScorePage,
    Testimonials
  },
  computed: {
    floorIndex: function() {
      if (this.rotator === null) {
        return -1;
      }
      if (this.rotator.isSnapping) {
        return -1;
      }
      return this.rotator.currentIndex;
    },
    appState: function() {
      return this.$store.getters.getAppState;
    },
    hasBeenRestarted: function() {
      return this.$store.getters.getHasBeenRestartedState;
    },
    questions: function() {
      return this.$store.getters.getQuestions;
    },
    rooms: function() {
      return this.$store.getters.getRooms;
    },
    meshes: function() {
      return this.$store.getters.getMeshes;
    },
    textures: function() {
      return this.$store.getters.getTextures;
    },
    clickedObj: function() {
      // return this.$store.getters.getClickedObj();
      let clickedObj = this.$store.getters.getClickedObj;

      return clickedObj;
    },
    questionsCompleted: function() {
      return this.$store.getters.getTotalQuestionsCompleted;
    }
  },
  watch: {
    appState(state, oldState) {
      if (state === "instruction" || state === "playing-show-card") {
        this.handleScrollerTweenForCardOpen();
        this.offsetHouse(false, this.updateButtonPositions);
        this.hideRoomButtons(true);

        if (!this.isMobile && state === "playing-show-card") {
          this.stopAllThrobbing();
          this.startActiveRoomButtonThrob();
        }
      } else if (state === "playing") {
        this.handleScrollerTweenForCardClose();
        this.offsetHouse(true, this.updateButtonPositions);

        setTimeout(() => {
          this.stopAllThrobbing();
          this.throbAllRoomButtons();
        }, 1000);

        if (this.isMobile) {
          this.HideCard();
          // this.throbAllRoomButtons();
        }
      } else if (state === "finished") {
        this.gameoverHouse(false);
        this.fadeSkybox(true);
      }

      if (state === "intro-anim") {
        this.$bus.$emit("loader/toggle", false);
        if (this.hasBeenRestarted) {
          this.gameoverHouse(true);
          this.fadeSkybox(true);
          this.showRoomButtons = false;
        }
        this.StartIntroAnim();
      }

      if (state === "instruction") {
        this.stopAllThrobbing();

        if (this.roomObjs.length === 0) {
          setTimeout(() => {
            this.setupRoomObjsData();
            this.throbAllRoomButtons();
          }, 1000);
        } else {
          this.throbAllRoomButtons();
        }
      }

      if (
        (state === "playing-show-card" || state === "playing") &&
        oldState === "instruction"
      ) {
        // this.handleInstructionConfirmed();
      }

      if (state === "playing-show-card" && this.isMobile) {
        this.fadeScroller(true);
      }

      if (oldState === "intro-anim" && state === "instruction") {
        this.allQuestionsAnswered = false;

        setTimeout(() => {
          this.showRoomButtons = true;
          this.throbAllRoomButtons();
        }, 1000);
      }
    },
    floorIndex: function(value) {
      if (!this.rotator.gameEnabled || value < 0) {
        return;
      }

      this.roomIndex = value;
      this.SwapTexture(true, this.roomIndex);

      // if (this.questionsCompleted < TOTAL_QUESTIONS) {
      this.setupRoomObjsData();
      // }
    },
    hasBeenRestarted(state, oldState) {
      if (state) {
        this.allQuestionsAnswered = false;
      }
    },
    showingQuestion(state, oldState) {
      if (!state) {
        this.activeRoomObjectIndex = null;
      }
    }
  },
  beforeMount() {
    // This ensures our scene is always at the correct aspect ratio
    window.addEventListener("resize", this.GetContainerDimensions);
  },
  mounted() {
    this.mountPlaneAnim("commercial");
    if (this.$bus.scenesLoaded) {
      this.$store.dispatch("switchBuilding", "commercial");
      this.setBwTextures();
    } else {
      this.$bus.$on("scenes-loaded", () => {
        this.setBwTextures();
      });
    }

    // if(this.isMobile) {
    //   this.$bus.$emit('show-win-button');
    // }
  },
  beforeDestroy() {
    this.resetSceneObjectPositions();

    window.removeEventListener("resize", this.GetContainerDimensions);
    window.removeEventListener("snapStartEvent", this.handleCameraSnapStart);
    window.removeEventListener("snapEndEvent", this.handleCameraSnapEnd);

    this.rotator.DestroyAllListeners(
      this.$refs.scroll_bg,
      this.$refs.scroll_left,
      this.$refs.scroll_right
    );
  },
  methods: {
    startThrob(nextQuestionRoomIndex, nextQuestionIndex) {
      // console.log("this.roomIndex:  ", this.roomIndex);
      // console.log("nextQuestionRoomIndex:  ", nextQuestionRoomIndex);
      // console.log("nextQuestionIndex:  ", nextQuestionIndex);

      // set a timeout to wait for the rotator to finish snapping if we're going to a different room
      const timeoutDelay = nextQuestionRoomIndex !== this.roomIndex ? 1500 : 0;

      setTimeout(() => {
        this.stopAllThrobbing();
        this.roomObjs[nextQuestionIndex].tl.play(0);
      }, timeoutDelay);
    },
    setBwTextures() {
      console.log("heyyo did we switch bw");
      for (let room of this.rooms) {
        console.log(room);

        let aux = room.id === "Livingroom" ? this.meshes.get("Fire") : null;
        let mesh = this.meshes.get(room.id);
        let initialColor = mesh.material.color.clone();
        let goalColor = new THREE.Color(0x2f6619);
        let goalMap = this.textures.get(room.id + "BW");
        let swapSpeed = this.tweenSpeeds.dur.roomFadeOut;

        if (room.id === "ParkingArea") {
          mesh.material = mesh.material.clone();
          goalColor = new THREE.Color(0xffffff);
          goalMap = this.textures.get(room.id);
          mesh.material.map = goalMap;
          mesh.material.color = initialColor;
          mesh.material.needsUpdate = true;
        }

        console.log("initialColor:  ", initialColor);
        console.log("goalColor:  ", goalColor);

        TweenMax.to(initialColor, swapSpeed, {
          r: goalColor.r,
          g: goalColor.g,
          b: goalColor.b,
          onUpdate: () => {
            mesh.material.color = initialColor;
            if (aux != null) {
              aux.material.color = initialColor;
            }
          },
          onComplete: () => {
            mesh.material.map = goalMap;
            mesh.material.color = goalColor;
            mesh.material.needsUpdate = true;
            if (aux != null) {
              aux.material.map = goalMap;
              aux.material.needsUpdate = true;
            }
          }
        });
      }
      // setTimeout(() => {
      //   this.SwapTexture(true, 0);
      // }, 3000);
    },
    resetSceneObjectPositions() {
      this.walls.position.z = 0;
    },
    Test: function() {
      console.log("Testing the buttons");
    },
    handleHowToOverlayEnter: function(el, done) {
      TweenMax.to(el, this.tweenSpeeds.dur.howToOverlayFade, {
        opacity: 1,
        onComplete: done
      });
    },
    handleHowToOverlayLeave: function(el, done) {
      TweenMax.to(el, this.tweenSpeeds.dur.howToOverlayFade, {
        opacity: 0,
        onComplete: done
      });
    },
    returnRoomObjStatus(data) {
      // if (!data.completed) {
      //   return "unanswered";
      // } else if (data.selectedIndex === data.correctIndex) {
      //   return "answeredCorrect";
      // } else {
      //   return "answeredIncorrect";
      // }

      return "unanswered";
    },
    setupRoomObjsData() {
      // kill old timelines
      for (let i = 0; i < this.roomObjs.length; i++) {
        this.roomObjs[i].tl.kill();
      }

      this.roomObjs.length = 0;
      this.roomButtonTl = [];
      const questions = this.$store.getters.getQuestionsById(this.roomIndex);

      if (questions === null) {
        return;
      }

      for (let objectIndex = 0; objectIndex < questions.length; objectIndex++) {
        if (!questions[objectIndex].hasOwnProperty("position")) {
          continue;
        }

        const questionPos = questions[objectIndex].position;
        let objVector = new THREE.Vector3(
          questionPos.x,
          questionPos.y,
          questionPos.z
        );
        const widthHalf = this.renderer.domElement.width / 2;
        const heightHalf = this.renderer.domElement.height / 2;
        const data = questions[objectIndex];
        const roomObjTl = new TimelineMax({
          paused: true,
          repeat: -1
        });

        data.status = this.returnRoomObjStatus(questions[objectIndex]);

        objVector.project(this.camera);
        objVector.x = objVector.x * widthHalf + widthHalf;
        objVector.y = -(objVector.y * heightHalf) + heightHalf;
        objVector.z = 0;

        this.roomObjs.push({
          id: objectIndex,
          roomIndex: this.roomIndex,
          text: `Object #${objectIndex}`,
          data,
          top: objVector.y,
          left: objVector.x,
          // completed: this.$store.getters.getQuestionByIds(
          //   this.roomIndex,
          //   objectIndex
          // ).completed,
          completed: false,
          ref: objectIndex + "room" + this.roomIndex,
          status: data.status,
          name: this.rooms[this.roomIndex].name,
          tl: roomObjTl
        });
      }

      this.updateButtonPositions();

      this.$nextTick(() => {
        this.addTweensToRoomButtonTls();
        // console.log('this.roomObjs:  ', this.roomObjs);
      });
    },
    updateButtonPositions() {
      const questions = this.$store.getters.getQuestionsById(this.roomIndex);
      let state = this.appState;

      for (
        let objectIndex = 0;
        objectIndex < this.roomObjs.length;
        objectIndex++
      ) {
        let roomObj = this.roomObjs[objectIndex];
        const questionPos = questions[objectIndex].position;
        let objVector;

        if (state === "instruction" || state === "playing-show-card") {
          objVector = new THREE.Vector3(
            questionPos.x,
            questionPos.y,
            questionPos.z
          );
        } else {
          objVector = new THREE.Vector3(
            questionPos.x + 0.6,
            questionPos.y,
            questionPos.z - 0.6
          );
        }

        const widthHalf = this.renderer.domElement.width / 2;
        const heightHalf = this.renderer.domElement.height / 2;

        objVector.project(this.camera);
        objVector.x = objVector.x * widthHalf + widthHalf;
        objVector.y = -(objVector.y * heightHalf) + heightHalf;
        objVector.z = 0;

        roomObj.left = objVector.x;
        roomObj.top = objVector.y;

        this.$bus.$emit("room-button-pos-change", {
          top: roomObj.top,
          left: roomObj.left
        });

        Vue.set(this.roomObjs, objectIndex, roomObj);
      }
    },
    handleCameraSnapStart() {
      // fade out current room objects
      this.isSnapping = true;

      // if (this.questionsCompleted < TOTAL_QUESTIONS) {
      this.hideRoomButtons(false);
      // }
    },
    handleCameraSnapEnd() {
      this.isSnapping = false;

      if (this.isMobile) {
        setTimeout(() => {
          this.throbAllRoomButtons();
        }, 1000);
      } else if (this.appState === "playing") {
        setTimeout(() => {
          this.throbAllRoomButtons();
        }, 1000);
      }
    },
    handleRoomButtonEnter(el, done) {
      TweenMax.fromTo(
        el,
        this.tweenSpeeds.dur.objectFadeIn,
        {
          opacity: 0
        },
        {
          opacity: 1
        }
      );

      done();
    },
    handleScrollerTweenForCardOpen() {
      if (this.isMobile) {
        this.fadeScroller(true);
      } else {
        TweenMax.to(
          this.$refs.scroller,
          this.tweenSpeeds.dur.scrollerTweenSpeedForCard,
          {
            left: (window.innerWidth * 0.7) / 2 + "px",
            opacity: 1,
            ease: this.tweenSpeeds.ease.house,
            pointerEvents: "auto"
          }
        );
      }
    },
    handleScrollerTweenForCardClose() {
      if (this.isMobile) {
        this.fadeScroller(false);
      } else {
        TweenMax.to(
          this.$refs.scroller,
          this.tweenSpeeds.dur.scrollerTweenSpeedForCard,
          {
            left: "50%",
            opacity: 1,
            ease: this.tweenSpeeds.ease.house,
            pointerEvents: "auto"
          }
        );
      }
    },
    gameoverHouse: function(restarting) {
      // TweenMax.to(this.$bus.scene.position, this.tweenSpeeds.dur.gameoverOffset, {
      //   x: restarting === true ? 0 : -3,
      //   z: restarting === true ? 0 : 3,
      //   ease: this.tweenSpeeds.ease.house
      // });
      TweenMax.to(
        this.$bus.scene.position,
        this.tweenSpeeds.dur.gameoverOffset,
        {
          x: restarting === true ? 0 : -3,
          z: restarting === true ? 0 : 3,
          ease: this.tweenSpeeds.ease.house
        }
      );
    },
    offsetHouse: function(returning, callback) {
      if (this.isMobile) {
        return;
      }
      if (callback) {
        callback = callback.bind(this);
      }
      if (returning) {
        // this means the intro card is fading out
        // TweenMax.to(this.$bus.scene.position, this.tweenSpeeds.dur.sceneOffset, {
        //   x: 0,
        //   z: 0,
        //   ease: this.tweenSpeeds.ease.house,
        //   onStart: callback
        // });
        TweenMax.to(
          this.$bus.scene.position,
          this.tweenSpeeds.dur.sceneOffset,
          {
            x: 0,
            z: 0,
            ease: this.tweenSpeeds.ease.house,
            onStart: callback
          }
        );
      } else {
        // TweenMax.to(this.$bus.scene.position, this.tweenSpeeds.dur.sceneOffset, {
        //   x: -0.6,
        //   z: 0.6,
        //   ease: this.tweenSpeeds.ease.house,
        //   onStart: callback
        // });
        TweenMax.to(
          this.$bus.scene.position,
          this.tweenSpeeds.dur.sceneOffset,
          {
            x: -0.6,
            z: 0.6,
            ease: this.tweenSpeeds.ease.house,
            onStart: callback
          }
        );
      }
    },
    handleClickOutside(e) {
      // console.log('running handleClickOutside()');
      // console.log('e:  ', e);

      let roomButtonClicked = false;
      let idClicked = e.target.id;
      // let moreInfoButtonClicked = false;

      if (
        idClicked === "moreInfoButton" ||
        idClicked === "confirmInstructionsButton"
      ) {
        // moreInfoButtonClicked = true;
        // this.$store.dispatch('updateAppState', { state: 'instruction' });
        return;
      }

      if (e.target.classList.contains("room-button")) {
        roomButtonClicked = true;
      }

      if (!roomButtonClicked) {
        Array.from(e.target.children).forEach(el => {
          if (el.classList.contains("room-button")) {
            roomButtonClicked = true;
          }
        });
      }

      if (roomButtonClicked) {
        return;
      } else {
        this.HideCard();
      }
    },
    HideCard: function() {
      return new Promise((res, rej) => {
        if (this.showingQuestion) {
          if (this.$refs.questionCard) {
            this.$refs.questionCard.handleCardClose();
          }
        }
  
        // if (this.questionsCompleted !== TOTAL_QUESTIONS) {
        console.log("dispatching inside HideCard()!!!");
        this.$store.dispatch("updateAppState", { state: "playing" });
        // }
  
        if (this.isMobile) {
          this.stopAllThrobbing();
          this.throbAllRoomButtons();
        }
  
        setTimeout(() => {
          this.showingQuestion = false;
          res();
        }, this.tweenSpeeds.dur.cardShow * 1000);
      });
    },
    showNextQuestion: async function() {
      await this.HideCard();

      this.setNextQuestionIndexes();

      this.setClickedObj(this.nextQuestionRoomIndex, this.nextQuestionIndex);

      if (this.nextQuestionRoomIndex !== this.roomIndex) {
        this.rotator.SetRoomIndex(this.nextQuestionRoomIndex % 6);
      }

      // show the selected question
      setTimeout(() => {
          this.handleRoomButtonClick(null, { roomIndex: this.nextQuestionRoomIndex, id: this.nextQuestionIndex });
        }, 500);

      this.showingQuestion = true;
    },
    hideRoomButtons: function(reverse) {
      let els = document.querySelectorAll(".blinkers");

      TweenMax.to(els, this.tweenSpeeds.dur.roomButtonHide, {
        opacity: reverse ? 1 : 0
      });
    },
    addTweensToRoomButtonTls: function() {
      this.roomObjs.forEach((roomObj, index) => {
        // if (roomObj.completed) {
        //   return;
        // }

        let tl = roomObj.tl;
        const wrapper = document.getElementById(roomObj.ref);
        const outerCircleEl = wrapper.querySelector(".unanswered-outer-circle");
        const innerCircleEl = wrapper.querySelector(".unanswered-inner-circle");

        tl.add(
          TweenMax.fromTo(
            outerCircleEl,
            2,
            {
              scale: 1
            },
            {
              scale: 6,
              opacity: 0
            }
          )
        );

        tl.add(
          TweenMax.fromTo(
            innerCircleEl,
            0.9,
            {
              scale: 0.5
            },
            {
              scale: 1.5
            }
          ),
          0
        );

        // this just adds a delay to the end of timeline
        tl.set({}, {}, "+=0.5");
      });
    },
    setNextQuestionIndexes: function() {
      // needs to set:  this.nextQuestionRoomIndex, this.nextQuestionIndex

      if (!this.clickedObj) {
        // case:  user pressed confirmation on how to play (first run)
        this.nextQuestionRoomIndex = 0;
        this.nextQuestionIndex = 0;
        return;
      }

      const currentRoomIndex = this.clickedObj.roomIndex;
      const currentRoomTotalQuestions = this.rooms[currentRoomIndex].questions
        .length;
      const currentQuestionIndex = this.clickedObj.questionIndex;
      const totalRooms = this.rooms.length;

      if (currentQuestionIndex + 1 > currentRoomTotalQuestions - 1) {
        // case: next question should be in next room

        // set next room index
        if (currentRoomIndex + 1 > totalRooms - 1) {
          // case: next room should be 0 room
          this.nextQuestionRoomIndex = 0;
        } else {
          // case: next room is current room + 1
          this.nextQuestionRoomIndex = currentRoomIndex + 1;
        }

        // set next question index
        this.nextQuestionIndex = 0;
      } else {
        // set next question index
        this.nextQuestionIndex = currentQuestionIndex + 1;
      }

      // let questionFound = false;

      // for (let i = 0; i < this.rooms.length; i++) {
      //   // offset so we start at current room and loop through all elements
      //   let offsetIndex = (i + this.roomIndex) % this.rooms.length;

      //   for (let j = 0; j < this.rooms[offsetIndex].questions.length; j++) {
      //     let question = this.rooms[offsetIndex].questions[j];

      //     if (!question.completed) {
      //       this.nextQuestionRoomIndex = offsetIndex;
      //       this.nextQuestionIndex = j;
      //       questionFound = true;
      //       break;
      //     }
      //   }

      //   if (questionFound) {
      //     break;
      //   }
      // }

      // if (!questionFound) {
      //   console.error("next question not found!");
      //   return;
      // }

      // console.log('nextQuestionRoomIndex:  ', this.nextQuestionRoomIndex);
      // console.log('nextQuestionIndex:  ', this.nextQuestionIndex);
    },
    handleAllQuestionsAnswered: function() {
      this.allQuestionsAnswered = true;

      this.hideRoomButtons(false);

      this.rotator.SetRoomIndex(0);

      this.HideCard();

      this.introAnimTl.shiftChildren(0);

      this.fadeScroller(true);

      this.reverseIntroAnim();

      this.fadeVeggies(true);

      setTimeout(() => {
        this.$store.dispatch("updateAppState", {
          state: "finished"
        });
      }, this.tweenSpeeds.dur.showFinalScoreDelay * 1000);
    },
    fadeScroller: function(reverse) {
      // console.log('RUNNING FADE SCROLLER:  reverse:  ', reverse);
      TweenMax.to(this.$refs.scroller, this.tweenSpeeds.dur.itemFadeIn, {
        opacity: reverse ? 0 : 1,
        pointerEvents: reverse ? "none" : "auto"
      });
    },
    showPlayAgainButton() {
      let el = document.querySelector(".play-again-button-wrapper");

      TweenMax.to(el, this.tweenSpeeds.dur.itemFadeIn, {
        opacity: 1,
        delay: 2,
        pointerEvents: "auto"
      });
    },
    handleInstructionConfirmed: function() {
      this.HideCard();
      // debugger;
      if (this.isMobile) {
        this.setupRoomObjsData();
        this.fadeScroller(false);
        this.showingQuestion = false;
        this.throbAllRoomButtons();
      } else {
        this.stopAllThrobbing();
        this.setupRoomObjsData();
        this.showNextQuestion();
        this.startActiveRoomButtonThrob();
        setTimeout(() => {
          this.handleRoomButtonClick(null, { roomIndex: 0, id: 0 });
        }, 500);
      }
    },
    stopAllThrobbing: function() {
      for (let i = 0; i < this.roomObjs.length; i++) {
        if (this.roomObjs[i].tl === null) {
          continue;
        }

        this.roomObjs[i].tl.progress(0);
        this.roomObjs[i].tl.pause();
      }
    },
    throbAllRoomButtons: function() {
      for (let i = 0; i < this.roomObjs.length; i++) {
        if (this.roomObjs[i].tl === null) {
          continue;
        }

        this.roomObjs[i].tl.play();
      }
    },
    startActiveRoomButtonThrob: function() {
      if (this.roomObjs === null || this.activeRoomObjectIndex === null) {
        return;
      }
      if (this.roomObjs[this.activeRoomObjectIndex] === null) {
        return;
      }

      if (this.roomObjs[this.activeRoomObjectIndex].tl === null) {
        return;
      }

      this.roomObjs[this.activeRoomObjectIndex].tl.play();
    },
    reverseIntroAnim() {
      this.fadeInteriorShadow();
      this.introAnimTl.reverse();
    },
    indicateRoomButton: function(id) {
      if (!this.showingQuestion) {
        return;
      }

      let els = document.querySelectorAll(".blinkers");

      els.forEach(el => {
        if (el.id === id) {
          // scale up
          TweenMax.to(el, 0.5, {
            scale: 2,
            ease: Power2.easeOut
          });
        } else {
          // scale down
          TweenMax.to(el, 0.5, {
            scale: 1,
            ease: Power2.easeOut
          });
        }
      });
    },
    handleContinueClicked: function() {
      // this.rotator.SetRoomIndex(0) - this will rotate to the correct room!

      if (this.isMobile) {
        // hide the question card
        this.$store.dispatch("updateAppState", {
          state: "playing"
        });
      } else {
        this.showNextQuestion();
      }
    },
    handleFinishClicked: function() {
      this.handleAllQuestionsAnswered();
    },
    setClickedObj: function(nextQuestionRoomIndex = 0, nextQuestionIndex = 0) {
      this.nextQuestionRoomIndex = nextQuestionRoomIndex;
      this.nextQuestionIndex = nextQuestionIndex;
      this.activeRoomObjectIndex = nextQuestionIndex;

      this.showingQuestion = false;

      this.$store.dispatch("setClickedObj", {
        nextQuestionRoomIndex,
        nextQuestionIndex
      });

      this.startThrob(nextQuestionRoomIndex, nextQuestionIndex);
    },
    handleSubmitClicked: function(roomObj) {
      let that = this;

      console.log("this.questionsCompleted:  ", this.questionsCompleted);
      // console.log("total_questions:  ", TOTAL_QUESTIONS);

      // if (this.questionsCompleted >= TOTAL_QUESTIONS) {
      //   this.allQuestionsAnswered = true;
      // }

      // update this.roomObjs
      this.roomObjs = this.roomObjs.map((item, index) => {
        let tempRoomObj = item;

        if (tempRoomObj.id === that.nextQuestionIndex) {
          tempRoomObj.data = roomObj;
          tempRoomObj.status = roomObj.status;
        }

        return tempRoomObj;
      });

      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    handleRoomButtonClick: function(e, data) {
      // this.$bus.$emit('room-button-click');
      let dataChangeDelay = 300;
      let nextQuestionRoomIndex = data.roomIndex;
      let nextQuestionIndex = data.id;

      // if(this.activeRoomObjectIndex !== null) {
      //   this.roomObjs[this.activeRoomObjectIndex].tl.pause(0);
      // }

      this.activeRoomObjectIndex = nextQuestionIndex;

      if (this.showingQuestion) {
        // if already showing question
        this.$refs.questionCard.handleCardClose(
          this.tweenSpeeds.dur.questionCardSwap
        );

        let that = this;

        setTimeout(() => {
          that.setClickedObj(nextQuestionRoomIndex, nextQuestionIndex);

          that.showingQuestion = true;

          that.$nextTick(() => {
            that.$refs.questionCard.handleCardOpen();
          });
        }, dataChangeDelay);
      } else {
        this.setClickedObj(nextQuestionRoomIndex, nextQuestionIndex);

        this.showingQuestion = true;

        this.$nextTick(() => {
          this.$refs.questionCard.handleCardOpen();
        });
      }

      if (this.showingQuestion && this.appState !== "playing-show-card") {
        this.$store.dispatch("updateAppState", { state: "playing-show-card" });
      }
    },
    // SetupSplashRotator: async function() {
    //   try {
    //     const result = await isTouch();
    //     let bgScroll = this.$el;

    //     if (result) {
    //       this.rotator.AddTouchEvent(bgScroll);
    //     } else {
    //       // console.log(this.rotator);
    //       this.rotator.AddMouseEvent(bgScroll);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    DestroySplashRotator: function() {
      let bgScroll = document.body;
      this.rotator.DestroySplashEvents(bgScroll);
    },
    SetupRotater: async function() {
      this.DestroySplashRotator();
      try {
        const result = await isTouch();
        let leftScroll = this.$refs.scroll_left;
        let rightScroll = this.$refs.scroll_right;
        let bgScroll = this.$refs.scroll_bg;

        if (result) {
          this.rotator.AddTouchEvents(bgScroll, rightScroll, leftScroll);
        } else {
          this.rotator.AddMouseEvents(bgScroll, rightScroll, leftScroll);
        }
      } catch (error) {
        console.log(error);
      }
    },
    LoadScene: function() {
      // Enable smooth shading for all the meshes to solve the marshmellow issue
      this.$store.dispatch("updateAppState", { state: "introduction" });

      // when we snap to new room, swap it to its original textures
      // and have all other rooms swap to green textures
      window.addEventListener("snapStartEvent", () => {
        if (this.rotator.gameEnabled) {
          this.SwapTexture(false, this.roomIndex);
        }
      });

      // this sphere will help us see where the camera is focused
      var sphere = this.AddTestObject(new THREE.Vector3(0, 1, 0));
      // this.$bus.scene.position.add(new THREE.Vector3(5, 0, 0));
      this.rotator = new Rotator(this.$bus.scene, sphere);
      this.rotator._camera.obj = this.camera;

      // var startSpherePos = sphere.position;
      // var sphereTimer = 0;
      // setInterval(() => {
      //   console.log("updating lookat");
      //   this.camera.lookAt(sphere);
      //   sphere.position.add(
      //     new THREE.Vector3(startSpherePos.x + Math.sin(sphereTimer), 0, 0)
      //   );
      //   sphereTimer += 0.1;
      // }, 1000);

      this.CameraZoom = this.CameraZoom.bind(this);
      this.$bus.scene.rotation.y = Math.PI / 4; // - 0.05

      this.CameraZoom();
      this.fadeInScene();
    },
    StartIntroAnim: function() {
      // console.log('running start intro anim');
      this.CameraZoom();
      this.rotator.snapSpeed = 0.001;
      this.rotator.canSnap = true;
      this.introAnimTl = new TimelineMax();

      this.walls = this.$bus.scene.getObjectByName("OuterShell", true);

      this.EnableRotator = this.EnableRotator.bind(this);
      this.EnableRotator();
      this.rotator.SetRoomIndex(0);

      this.introAnimTl.add([
        TweenMax.to(this.cameraFov, this.tweenSpeeds.dur.cameraFov, {
          fov: 10,
          onUpdate: this.UpdateProjection,
          ease: this.tweenSpeeds.ease.house
        }),
        TweenMax.to(
          this.camera.position,
          this.tweenSpeeds.dur.introCameraPosition,
          {
            x: 30,
            y: 10,
            onUpdate: this.CameraZoom,
            ease: this.tweenSpeeds.ease.house
          }
        ),
        TweenMax.to(this.walls.position, this.tweenSpeeds.dur.commercialWalls, {
          z: -1000,
          ease: this.tweenSpeeds.ease.house
        }),
        TweenMax.to(
          this.rotator._camera.target.position,
          this.tweenSpeeds.dur.cameraPos2,
          {
            y: 0,
            onUpdate: this.CameraZoom,
            ease: this.tweenSpeeds.ease.house
          }
        ),
        TweenMax.to(this.camera.position, this.tweenSpeeds.dur.cameraPos3, {
          onUpdate: this.CameraZoom,
          onStart: () => {
            this.rotator.SetRoomIndex(0);
            this.fadeVeggies();
            this.fadeSkybox(false);
            this.fadeExteriorShadow();
          },
          onComplete: () => {
            this.rotator.SetRoomIndex(0);
            this.EnableGame();
            this.rotator.gameEnabled = true;
            console.log(this.$bus.scene);
          },
          y: 10,
          x: 15,
          ease: this.tweenSpeeds.ease.house
        })
      ]);
      this.introAnimTl.shiftChildren(1.2);
    },
    SwapTexture: function(fadeIn, roomIndex) {
      const room = this.meshes.get(this.rooms[roomIndex].id);
      let aux =
        this.rooms[roomIndex].id === "Livingroom"
          ? this.meshes.get("Fire")
          : null;
      const bwTexture = this.textures.get(this.rooms[roomIndex].id + "BW");
      const regTexture = this.textures.get(this.rooms[roomIndex].id);

      let initialColor = room.material.color.clone();
      let goalColor = this.textureSwapper.fadeColor;
      let goalMap = bwTexture;
      let swapSpeed = this.tweenSpeeds.dur.roomFadeOut;

      if (fadeIn) {
        goalColor = this.textureSwapper.unfadeColor;
        goalMap = regTexture;
        swapSpeed = this.tweenSpeeds.dur.roomFadeOut;
        room.material.map = goalMap;
        room.material.color = initialColor;
        room.material.needsUpdate = true;
      }

      TweenMax.to(initialColor, swapSpeed, {
        r: goalColor.r,
        g: goalColor.g,
        b: goalColor.b,
        onUpdate: function() {
          room.material.color = initialColor;
          if (aux != null) {
            aux.material.color = initialColor;
          }
        },
        onComplete: function() {
          room.material.map = goalMap;
          room.material.color = goalColor;
          room.material.needsUpdate = true;
        }
      });
    },
    fadeInScene: function() {
      let that = this;
      let fadeTimeline = new TimelineMax({
        onComplete: () => {
          console.log("did this update to intro");
          that.$store.dispatch("updateAppState", { state: "intro-anim" });
        }
      });

      fadeTimeline.add(
        TweenMax.to(this.meshes.get("EnvironmentSphere").material, 1, {
          opacity: 1
        })
      );

      let animations = [];
      this.$bus.scene.traverse(function(child) {
        if (
          child instanceof THREE.Mesh &&
          child != that.rotator._camera.target
        ) {
          animations.push(
            TweenMax.to(child.material, 1, {
              opacity: 1
            })
          );
        }
      });
      fadeTimeline.add(animations, 0.2);
    },
    fadeVeggies: function(reverse) {
      return;
      let that = this;
      let veggies = this.meshes.get("ExteriorVegetation");

      TweenMax.to(veggies.material, that.tweenSpeeds.dur.fadeVeggies, {
        opacity: reverse ? 1 : 0,
        ease: that.tweenSpeeds.ease.house
      });
    },
    fadeSkybox: function(fadeIn) {
      TweenMax.to(
        this.meshes.get("EnvironmentSphere").material,
        fadeIn == true ? 0.4 : 1,
        {
          opacity: fadeIn == true ? 1 : 0,
          ease: this.tweenSpeeds.ease.house
        }
      );
    },
    fadeShadow(callback) {
      return;
      TweenMax.to(
        this.meshes.get("ShadowDisc").material,
        this.tweenSpeeds.dur.fadeVeggies,
        {
          opacity: 0,
          ease: this.tweenSpeeds.ease.house,
          onComplete: callback
        }
      );
    },
    fadeExteriorShadow: function() {
      this.fadeShadow(this.showInteriorShadow);
    },
    fadeInteriorShadow: function() {
      this.fadeShadow(this.showExteriorShadow);
    },
    showShadow(texture) {
      let shadow = this.meshes.get("ShadowDisc");
      let nextMaterial = shadow.material.clone();
      nextMaterial.map = texture;
      shadow.material = nextMaterial;
      shadow.material.needsUpdate = true;

      TweenMax.fromTo(
        shadow.material,
        0.5,
        {
          opacity: 0
        },
        {
          opacity: 1
        }
      );
    },
    showExteriorShadow: function() {
      let shadow = this.meshes.get("Shadow");
      shadow.position.z = 0;
      this.showShadow(this.textures.get("ShadowExterior"));
    },
    showInteriorShadow: function(zPos) {
      if (zPos == null) zPos = -0.5;
      // this.shadow.mesh.position.z = zPos;
      this.showShadow(this.textures.get("ShadowInterior"));
    },
    UpdateCamera: function() {
      this.camera.updateProjectionMatrix();
    },
    UpdateProjection: function() {
      this.camera.fov = this.cameraFov.fov;
      this.camera.updateProjectionMatrix();
    },
    CameraZoom: function() {
      if (this.rotator) {
        this.camera.lookAt(this.rotator._camera.target.position);
      }
    },
    EnableGame: function() {
      this.allQuestionsAnswered = false;
      this.rotator.snapSpeed = 1;
      this.$store.dispatch("updateAppState", { state: "instruction" });
    },
    EnableRotator: function() {
      this.SetupRotater();
      this.rotatorEnabled = true;
      // this.rotator.UpdateCameraRotation(1, this.camera, this.$bus.scene)
    },
    animate: function() {
      requestAnimationFrame(this.animate);

      if (this.$bus.scene == null) {
        return;
      }
      if (this.rotatorEnabled) {
        let planeAnim = this;
        this.rotator.HandleRotation(
          this.camera,
          this.$bus.scene,
          this.isSnapping,
          planeAnim
        );
      }

      this.renderer.render(this.$bus.scene, this.camera);
    },
    UpdateRendererSize: function() {
      this.renderer.setSize(this.width, this.height);
      this.camera.aspect = this.width / this.height;
      if (this.isMobile) {
        this.camera.zoom = 0.75;
      } else {
        this.camera.zoom = 1;
      }
      this.camera.updateProjectionMatrix();
    },
    GetContainerDimensions: function(e) {
      this.width = this.elements.container.clientWidth;
      this.height = this.elements.container.clientHeight;
      this.UpdateRendererSize();
    },
    AddTestObject: function(position, opacity) {
      if (opacity == null) opacity = 0;
      var sphereGeo = new THREE.SphereGeometry(0.2, 32, 32);
      var sphereMat = new THREE.MeshBasicMaterial({
        color: 0x333333,
        transparent: true,
        opacity: opacity
      });
      var sphere = new THREE.Mesh(sphereGeo, sphereMat);
      sphere.position.set(position.x, position.y, position.z);
      this.$bus.scene.add(sphere);
      if (!opacity) sphere.visible = false;
      return sphere;
    },
    beforeTestimonialsEnter: function(el) {
      TweenMax.set(el, {
        y: "100%",
        opacity: 0
      });
    },
    testimonialsEnter: function(el, done) {
      TweenMax.to(el, this.tweenSpeeds.dur.testimonialsEnter, {
        y: "0%",
        opacity: 1,
        onComplete: done,
        ease: Power2.easeInOut
      });
    },
    testimonialsLeave: function(el, done) {
      TweenMax.to(el, this.tweenSpeeds.dur.testimonialsEnter, {
        y: "100%",
        opacity: 0,
        onComplete: this.handleFadePlayAgainButton.bind(this, done),
        ease: Power2.easeInOut
      });
    },
    beforeFinalScoreEnter: function(el) {
      if (this.previousAppState === "show-testimonials") {
        return;
      }

      TweenMax.set(el, {
        x: "100%",
        opacity: 0
      });
    },
    handleFadePlayAgainButton: function(done) {
      TweenMax.to("#playAgainButton", this.tweenSpeeds.dur.itemFadeIn, {
        opacity: 1
      });
    },
    handleFinalScoreEnter: function(el, done) {
      if (this.previousAppState === "show-testimonials") {
        this.handleFadePlayAgainButton.bind(this, done);
        return;
      }

      TweenMax.to(
        "#finalScoreComponent",
        this.tweenSpeeds.dur.finalScoreEnter,
        {
          x: "0%",
          opacity: 1,
          onComplete: this.handleFadePlayAgainButton.bind(this, done)
        }
      );
    },
    handleFinalScoreLeave: function(el, done) {
      // if(this.previousAppState === 'show-testimonials') {
      //   return;
      // }

      if (this.appState !== "intro-anim") {
        return;
      }

      TweenMax.to(
        "#finalScoreComponent",
        this.tweenSpeeds.dur.finalScoreEnter,
        {
          x: "100%",
          opacity: 0,
          ease: Power2.easeInOut,
          onComplete: done
        }
      );
    },
    handlePlayAgainButtonEnter: function(el, done) {
      TweenMax.to(el, this.tweenSpeeds.dur.itemFadeIn, {
        delay: 1.5,
        opacity: 1,
        ease: Power2.easeInOut,
        onComplete: done
      });
    },
    handlePlayAgainButtonLeave: function(el, done) {
      TweenMax.to(el, this.tweenSpeeds.dur.itemFadeIn, {
        opacity: 0,
        ease: Power2.easeInOut,
        onComplete: done
      });
    },
    handlePlayAgainButtonClick: function() {
      this.$store.dispatch("setAppStateForPlayAgain");
      this.$store.dispatch("setRoomsDataForPlayAgain");
      this.$store.dispatch("switchBuilding", "commercial");
    }
  }
};
</script>

<style lang='scss' scoped>
@import "../../assets/css/globals.scss";

#finalScoreComponent {
  transform: translateX(100%);
}

.planes {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  // height: 100vh;
  bottom: 0;
  // width: 50%;
  background-color: #49792f;

  // overflow-y: scroll;

  @include large {
    overflow-y: auto;
    overflow-x: hidden;
  }
}
#three-commercial-container {
  height: 100%;
  width: 100%;
}
#results {
  position: absolute;
  height: 60px;
  width: 90%;
  max-width: 400px;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  color: #efefef;
}
#scroller {
  position: absolute;
  height: 60px;
  width: 90%;
  max-width: 400px;

  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);

  opacity: 0;
  // pointer-events: none;

  background-color: rgba(0, 0, 0, 0.15);

  border-radius: 50px;

  z-index: 600;

  @include large {
    bottom: 20px;
  }
}
.scroll-arrow {
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  position: absolute;
  top: 0px;
  height: 100%;
  width: 60px;
  // background-color: rgba(30,30,30,0.75);

  transition: all 0.5s ease-out;
}

.scroll-arrow-left {
  transform: rotate(180deg);
}

#scroller_bg {
  position: absolute;
  height: 100%;
  margin: 0px 60px;
  width: calc(100% - 120px);
  // background-color:rgba(93, 93, 93, 0.5);
}
.scroll-left {
  left: 0px;
}
.scroll-right {
  right: 0px;
}

.scroller-indicators-container {
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  justify-content: space-around;
  align-items: center;

  height: 100%;
  width: 100%;

  // background-color: yellow;
}

.scroller-indicator-large,
.scroller-indicator-small {
  background-color: white;

  border-radius: 50%;

  opacity: 0.2;

  transition: all 0.5s ease-in-out;
}

.scroller-indicator-large {
  width: 10px;
  height: 10px;
}

.scroller-indicator-small {
  width: 2px;
  height: 2px;
}

.finished-indicator {
  background-color: #f7923b; /* $sun */
}

.current-indicator {
  transform: scale(2);
}

.how-to-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background-color: RGBA(0, 0, 0, 0.4);

  opacity: 0;
}

.scroll-arrow-left,
.scroll-arrow-right {
  height: 45px;
  width: 45px;

  &:hover {
    & circle {
      fill: white;
    }

    & path {
      fill: RGBA(73, 130, 52, 1);
    }
  }

  & circle {
    transition: all 0.3s ease-out;
    fill: RGBA(0, 0, 0, 0.3);
  }

  & path {
    transition: all 0.3s ease-out;
    fill: white;
  }
}

.hide-room-button {
  opacity: 0;
}

.playAgainButtonWrapper {
  position: absolute;
  top: 50%;
  left: 25%;

  color: $white;
  font-size: 14px;
  font-weight: 600;

  opacity: 0;

  width: 250px;

  transform: translateY(-50%) translateX(-50%);
  width: 250px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/PlaneAnims/CommercialPlaneAnim.vue